import { DetectorType, SecurityScanConclusionEnum } from '@repo/api-gw-sdk';

export const DETECTOR_OPTIONS = [
  {
    id: DetectorType.RansomwareBehavior,
    name: 'Ransomware',
    icon: 'material-symbols-skull-outline',
  },
  {
    id: DetectorType.Malware,
    name: 'Malware',
    icon: 'material-symbols-bug-report-outline-rounded',
  },
  {
    id: DetectorType.DataAnomaly,
    name: 'Anomalous activity',
    icon: 'material-symbols-line-axis',
  },
  {
    id: DetectorType.AiDataRisk,
    name: 'AI data risk',
    icon: 'material-symbols-auto-awesome-outline',
  },
  {
    id: DetectorType.DataExposureRisk,
    name: 'Data exposure risk',
    icon: 'material-symbols-globe',
  },
];

export const SECURITY_SCAN_CONCLUSION_OPTIONS = [
  {
    id: SecurityScanConclusionEnum.HighChanceForRansomware,
    name: 'Ransomware',
    icon: 'material-symbols-skull-outline',
  },
  {
    id: SecurityScanConclusionEnum.MalwareDetected,
    name: 'Malware',
    icon: 'material-symbols-bug-report-outline-rounded',
  },
  {
    id: SecurityScanConclusionEnum.DataAnomalyDetected,
    name: 'Anomalous activity',
    icon: 'material-symbols-line-axis',
  },
  {
    id: SecurityScanConclusionEnum.AiDataRiskDetected,
    name: 'AI data risk',
    icon: 'material-symbols-auto-awesome-outline',
  },
  {
    id: SecurityScanConclusionEnum.DataExposureRiskDetected,
    name: 'Data exposure risk',
    icon: 'material-symbols-globe',
  },
];
